import { createAction } from '@reduxjs/toolkit';
import type {
  ShapeDrawConfiguration, ShapeDrawShape,
} from './shapeDraw.state';

export const startShapeDraw = createAction(
  'FRONTEND_STATE_SHAPE_DRAW_START',
  ({ shape, configuration }: { shape: ShapeDrawShape; configuration: ShapeDrawConfiguration}) => ({
    payload: {
      shape,
      configuration,
    },
  })
);

export const stopShapeDraw = createAction(
  'FRONTEND_STATE_SHAPE_DRAW_STOP',
);
